import * as types from 'src/localization/types';

export const localized = (env: types.Env) => ({
  title: env.localizer('components.HelpInstitution.title'),
  description: env.localizer('components.HelpInstitution.description'),
  btn: env.localizer('components.HelpInstitution.btn')
});
